<template>
  <div class="article">
    <div v-if="loading" class="text-center p-5">
      <b-spinner label="Loading article"></b-spinner>
    </div>
    <b-container v-else-if="loadError" fluid="xxl" class="mt-4">
      <b-alert show variant="danger">{{ loadError }}</b-alert>
    </b-container>
    <template v-else-if="article">
      <PageTitle v-bind:title="article.title" :pretitle="'Article details'" />
      <ArticleDetails v-bind:article="article" />
    </template>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  import PageTitle from '@/components/PageTitle.vue'
  import ArticleDetails from '@/components/ArticleDetails.vue'

  export default {
    name: 'Article',
    data() {
      return {
        loading: true,
        loadError: null,
        requestSequence: 0,
      }
    },
    components: {
      ArticleDetails,
      PageTitle
    },
    computed: {
      ...mapState({
        article: state => state.article.article
      }),
    },
    watch: {
      '$route.params.id'() {
        this.loadArticle()
      }
    },
    mounted () {
      this.loadArticle()
    },
    methods: {
      async loadArticle() {
        const requestSequence = ++this.requestSequence
        const id = this.$route.params.id
        this.loading = true
        this.loadError = null
        try {
          await this.$store.dispatch('loadArticle', id)
        } catch (error) {
          if (requestSequence !== this.requestSequence) return
          this.loadError = error.response && error.response.status === 404
            ? `Article ${id} was not found`
            : error.message || `Article ${id} could not be loaded`
        } finally {
          if (requestSequence === this.requestSequence) this.loading = false
        }
      },
    }
  }
</script>
